import React, { useRef, useEffect } from 'react';
import Head from 'next/head';
import { ACCESSIBLE_TITLE } from 'Components/frameworks/portal/Portal.constants';
import Portal from 'Components/frameworks/portal/Portal';
type Props = {
  title: string;
};
export const BookingAccessibleTitle = ({ title }: Props) => {
  const titleRef = useRef<HTMLParagraphElement>(null);
  useEffect(() => {
    if (titleRef.current) {
      titleRef.current.focus();
    }
  }, [title]);
  return (
    <Portal name={ACCESSIBLE_TITLE}>
      <Head>
        <title key="title">{title}</title>
      </Head>
      <p ref={titleRef} className="sr-only" tabIndex={-1}>
        {title}
      </p>
    </Portal>
  );
};
